import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MessagesComponent } from './messages/messages.component';
import { ToastComponent } from './toast/toast.component';
import { ChatbotComponent } from './chatbot/chatbot.component';

@NgModule({
  declarations: [MessagesComponent, ToastComponent, ChatbotComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    HttpClientModule,
    RouterModule,
    InputTextModule,
    InputTextareaModule,
    CheckboxModule,
    ButtonModule,
    AvatarModule,
    TooltipModule,
    MessagesModule,
    ToastModule,
    NgxSpinnerModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    InputTextModule,
    InputTextareaModule,
    CheckboxModule,
    ButtonModule,
    AvatarModule,
    TooltipModule,
    MessagesModule,
    ToastModule,
    NgxSpinnerModule,
    MessagesComponent,
    ToastComponent,
    ChatbotComponent,
  ],
})
export class CoreUiModule {}
